import { CONTENT_TYPE } from "../store/constants";

const isContentDownloadable = ({
  contentType,
  videoType,
  isDownloadable,
  isAllowOutSideAppPdfDownload,
  format,
}) => {
  const isDownloadablePDF =
    isAllowOutSideAppPdfDownload && contentType === CONTENT_TYPE.DOCUMENT;
  if (!isDownloadablePDF && isDownloadable == 0) return false;

  switch (contentType) {
    case CONTENT_TYPE.FOLDER: {
      return false;
    }
    case CONTENT_TYPE.VIDEO: {
      if (videoType === "youtube-hosted") return false;
      return true;
    }
    case CONTENT_TYPE.DOCUMENT: {
      switch (format) {
        case "jpg":
        case "png":
        case "jpeg":
        case "zip":
          return false;
      }
      return true;
    }
    case CONTENT_TYPE.TEST: {
      return false;
    }
    case CONTENT_TYPE.LIVE_CLASS:
      return true;
    default:
      return false;
  }
};

export default isContentDownloadable;
